import { VaultV2TransactionType } from '@/types/enums'
import { TransactionType } from '@/types/legacy'

import type { VaultTransactionType } from './VaultTransactions.types'

export const PAGE_SIZE = 10

/**
 * Column IDs. The vault transactions feed only supports sorting by
 * `timestamp` (DESC). Other columns are kept as plain identifiers so the
 * legacy `useTableSettings` storage shape stays compatible.
 */
export const COLUMN_IDS = {
  Timestamp: 'Timestamp',
  TypeText: 'TypeText',
  AssetsUsd: 'AssetsUsd',
  User: 'User',
  TransactionHash: 'TransactionHash'
} as const

export const TRANSACTION_FILTER_OPTIONS = [
  { label: 'Vault Deposit', value: TransactionType.MetaMorphoDeposit },
  { label: 'Vault Transfer', value: TransactionType.MetaMorphoTransfer },
  { label: 'Vault Withdraw', value: TransactionType.MetaMorphoWithdraw }
]

/** Filter options for the V2 transaction-type filter, keyed on `VaultV2TransactionType`. */
export const VAULT_V2_TRANSACTION_FILTER_OPTIONS = [
  { label: 'Deposit', value: VaultV2TransactionType.Deposit },
  { label: 'Transfer', value: VaultV2TransactionType.Transfer },
  { label: 'Withdraw', value: VaultV2TransactionType.Withdraw }
]

/**
 * Map between the legacy GraphQL `TransactionType` enum used by the filter UI
 * and the `vault.transactions` `types` values. Keeping the filter values keyed
 * on the legacy enum leaves `TransactionTypeFilter` and persisted user
 * settings untouched.
 */
export const LEGACY_TO_VAULT_TRANSACTION_TYPE: Partial<
  Record<TransactionType, VaultTransactionType>
> = {
  [TransactionType.MetaMorphoDeposit]: 'deposit',
  [TransactionType.MetaMorphoWithdraw]: 'withdraw',
  [TransactionType.MetaMorphoTransfer]: 'transfer'
}

/** Map between the V2 filter's `VaultV2TransactionType` and the `vault.transactions` `types`. */
export const VAULT_V2_TO_VAULT_TRANSACTION_TYPE: Record<
  VaultV2TransactionType,
  VaultTransactionType
> = {
  [VaultV2TransactionType.Deposit]: 'deposit',
  [VaultV2TransactionType.Withdraw]: 'withdraw',
  [VaultV2TransactionType.Transfer]: 'transfer'
}

export const VAULT_TRANSACTION_TYPE_LABELS: Record<VaultTransactionType, string> = {
  deposit: 'Vault Deposit',
  withdraw: 'Vault Withdraw',
  transfer: 'Vault Transfer'
}

export const VAULT_V2_TRANSACTION_TYPE_LABELS: Record<VaultTransactionType, string> = {
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  transfer: 'Transfer'
}
